// Add global styles and fonts here

const theme = {
  colors: {
    purple: '#6636EF',
    teal: '#8DF6FF',
    peacock: '#46A1B4',
    marigold: '#FFD02B',
    marine: '#254C62',
    offBlack: '#111211',
    error: '#FF522D',
    background: {
      primary: '#FFFFFF', // white
      secondary: '#EFEFEF', // tiny gray
      teritary: '#E5E5E5', // light gray
      quarternary: '#C4C4C4', // darker gray
    },
    accents: {
      primary: '#6636EF', // purple
      secondary: '#8DF6FF', // teal
      tertiary: '#46A1B4', // peacock (blue)
      quarternary: '#FFD02B', // marigold (yellow)
      shadow: 'rgba(0, 0, 0, 0.1)',
      tealHighlight: 'rgba(141, 245, 255, 0.2)',
    },
    fonts: {
      primary: '#254C62', // marine (dark blue)
      secondary: '#111211', // off black
      tertiary: '#46A1B4', // peacock (blue)
      quarternary: '#BFBFBF', // gray
      againstLight: '#000000', // black
      againstDark: '#FFFFFF', // white
    },
  },
  fonts: {
    primary: 'Raleway',
    secondary: 'Gilroy',
    tertiary: 'Nunito',
    quarternary: 'Roboto',
    quintary: 'Woodford Bourne',
  },
}

export default theme
